// Глобальные константы

// Линк на "Terms of Service and License Agreement"
export const URL_TERMS_OS_SERVICE = "https://www.dbinvent.com/terms";

// Линк на "Privacy Policy"
export const URL_PRIVACY_POLICY = "https://www.dbinvent.com/privacy-policy";

// Линк на статью "Быстрый старт"
export const URL_QUICK_START_GUIDE = "https://www.dbinvent.com/rdbm/guide/getting-started";

// Линк на "задать вопрос в поддержу"
export const URL_SUPPORT_QUESTION = "https://www.dbinvent.com/contact-us";

// Куда отправляем почитать про зашифрованные и не защифрованные режимы сохранения
export const URL_SAVE_MODE_DETAILS = "https://www.dbinvent.com/rdbm/guide/licensing#privacy";

// Куда отправляем почитать про вытягивание лицензии с консолиn ToDo Не написано еще, вроде
export const URL_ENCRYPTED_RE_DOWNLOAD = "https://www.dbinvent.com/rdbm/guide/licensing";

// Куда отправляем почитать лицензирование
export const URL_LICENSING_MODEL = "https://www.dbinvent.com/rdbm/guide/licensing";

// Куда отправляем скачать дистрибутив
export const URL_SETUP_DOWNLOAD = "https://www.dbinvent.com/downloads";

// Адрес как раздел вообще
// true - нужен хотя бы как опциональный раздел при регистрации
// false - не нужен совсем, будет отсутсвовать и в профиле пользователя
export const USER_ADDRESS = true;

// Если USER_ADDRESS = true, делает адрес опциональным разделом при регистрации
export const USER_ADDRESS_OPTIONAL = true;

// Минимальная задержка между двумя шагами в ui. Необходима чтобы не было слишком быстрого 
// перехода между сценами, чтобы пользователь успевал прочитать, не было мерцания и тд.
export const LONG_DESIGN_DELAY = 2500;

export const NORMAL_DESIGN_DELAY = 1000;

export const SHORT_DESIGN_DELAY = 300;

export const RESEND_EMAIL_INTERVAL_SECS = 60

export const MIN_PASSWORD_LENGTH = 6;

// Маппинги
export const URL_SIGN_IN = "/back-end/auth/cabinet";
export const URL_SIGN_OUT = '/back-end/auth/';
export const URL_REFRESH_TOKEN = '/back-end/auth/refresh';
export const URL_RESET_PASSWORD_REQUEST = "/back-end/auth/reset";
export const URL_CHANGE_PASSWORD = "/back-end/auth/reset";
export const URL_RESET_PASSWORD_LINK_CLICK = "/back-end/auth/reset/{0}";

export const URL_CONFIRM_USER_CODE = '/back-end/user/confirm/{0}/{1}';
export const URL_CONFIRM_USER_CLICK = "/back-end/user/confirm/{0}";
export const URL_RESEND_CONFIRMATION = "/back-end/user/email/{0}/resend";
export const URL_SET_USER_EMAIL = "/back-end/user/email";
export const URL_DELETE_USER_EMAIL = URL_SET_USER_EMAIL;
export const URL_SET_USER_PASSWORD = "/back-end/user/password";
export const URL_LOAD_USER = "/back-end/user";
export const URL_GET_USER_SESSIONS = "/back-end/user/sessions";
export const URL_REVOKE_USER_SESSION = "/back-end/user/sessions/{0}";
export const URL_REVOKE_ALL_USER_SESSIONS = "/back-end/user/sessions/others";
export const URL_SET_USER_LOCALE = '/back-end/user/locale';
export const URL_CHANGE_USER_NAME = '/back-end/user/name';
export const URL_CHANGE_COMM_PREFS = '/back-end/user/communication/prefs';

export const URL_LOAD_CLIENT = "/back-end/client/{0}";
export const URL_DELETE_CLIENT = "/back-end/client/{0}";
export const URL_SUSPEND_CLIENT = "/back-end/client/{0}/suspend"
export const URL_SEARCH_CLIENT = "/back-end/client/search";
export const URL_REGISTER_NEW_CLIENT = "/back-end/client/";
export const URL_CHANGE_CLIENT_ADDRESS = "/back-end/client/address";
export const URL_CHANGE_BUSINESS_TYPE = "/back-end/client/type";

export const URL_SAVE_LICENSE = '/back-end/license/';
export const URL_SAVE_ENCRYPTED_LICENSE = '/back-end/license/encrypted';
export const URL_UPDATE_LICENSE = URL_SAVE_LICENSE;
export const URL_DELETE_LICENSE = URL_SAVE_LICENSE;
export const URL_LOAD_LICENSE = URL_SAVE_LICENSE;
export const URL_DOWNLOAD_LICENSE = '/back-end/license/{0}/download';
export const URL_PAY_LICENSE = "/back-end/license/{0}/pay"

export const URL_LOAD_COUNTRIES = "/back-end/misc/countries/{0}";

// Ошибки с бэка
export const CODE_AUTH_OAUTH_NO_EMAIL = 17;


// First, checks if it isn't implemented yet.
if (!String.prototype.format) {
    String.prototype.format = function() {
      var args = arguments;
      return this.replace(/{(\d+)}/g, function(match, number) { 
        return typeof args[number] != 'undefined'
          ? args[number]
          : match
        ;
      });
    };
  }